<template>
  <div class="iconWrapper">
    <i class="icon bi bi-exclamation" />
  </div>
  <div class="title">{{ $t("game.preGameModalChecksNoHost.title") }}</div>
  <div class="text">{{ $t("game.preGameModalChecksNoHost.text") }}</div>
  <Button :label="$t('game.preGameModalChecksNoHost.button')" class="btn outline secondary" @click="$emit('back')" />
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.iconWrapper {
  width: 64px;
  height: 64px;

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  font-size: 48px;

  background-color: #f40000;
}

.title {
  font-size: 32px;
  font-weight: 700;
}

.text {
  font-size: 18px;
}

@media screen and (max-width: $small-screen) {
  .title {
    font-size: 20px;
  }

  .text {
    font-size: 14px;
  }
}

.btn {
  margin-top: 24px;
  border: 2px solid #464646 !important;
}
</style>

<script setup lang="ts">
defineEmits(["back"]);
</script>
